import model from '@/model/popup';

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign,func-names
    Vue.prototype.$alert = function (text, desc = '') {
      return model.addAlert(text, desc);
    };
    // eslint-disable-next-line no-param-reassign,func-names
    Vue.prototype.$confirm = function (text, desc = '') {
      return model.addConfirm(text, desc);
    };
    // eslint-disable-next-line no-param-reassign,func-names
    Vue.prototype.$prompt = function (text, desc = '', defValue = '') {
      return model.addPrompt(text, desc, defValue);
    };
    // eslint-disable-next-line no-param-reassign,func-names
    Vue.prototype.$goto = function (text, to, buttonText, desc = '') {
      return model.addGoto(text, to, buttonText, desc);
    };
  },
};
